import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';
import startsWith from 'lodash/startsWith';
import isNil from 'lodash/isNil';

export const getUtmData = (query, referrer) => {
  const utmData = pickBy(query, (_, key) => startsWith(key, 'utm_'));
  const source = referrer || 'direct';
  const medium = source.includes('google.com') ? 'organic' : 'referral';

  return omitBy(
    {
      utm_source: source,
      utm_medium: source === 'direct' ? null : medium,
      ...utmData,
    },
    isNil,
  );
};
